<script lang="ts">
    import type {TabPanelId} from 'shared/ui-widgets/tabset/types';
    import {TabPanel} from '@rgossiaux/svelte-headlessui';

    export let tabPanelId: TabPanelId;
    export let hidden = false;
</script>

<TabPanel role="tabpanel"
          class="kp-generic-tab-panel-content {tabPanelId} {hidden ? 'tabset-item-hidden' : ''}">
    <slot/>
</TabPanel>

<style lang="less">
    :global {
        .kp-generic-tab-panel-content {
            &.tabset-item-hidden {
                display: none;
            }
        }
    }
</style>